import { render, staticRenderFns } from "./products.vue?vue&type=template&id=6b3da022&scoped=true&"
import script from "./products.vue?vue&type=script&lang=js&"
export * from "./products.vue?vue&type=script&lang=js&"
import style1 from "./products.vue?vue&type=style&index=1&id=6b3da022&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3da022",
  null
  
)

export default component.exports